import create from '@verndale/core';

import initGlobalComponents from './components/global';
import { reactModule } from './utils/react';

const components = [
  {
    name: 'Footer',
    loader: () => import('./components/footer')
  },
  {
    name: 'Header',
    loader: () => import('./components/header')
  },
  {
    name: 'KeyDates',
    loader: () => import('./components/key-dates')
  },
  {
    name: 'Stats',
    loader: () => import('./components/stats')
  },
  {
    name: 'RoundedStats',
    loader: () => import('./components/rounded-stats')
  },
  {
    name: 'PartnersLogos',
    loader: () => import('./components/partners-logos')
  },
  {
    name: 'Testimonials',
    loader: () => import('./components/testimonials')
  },
  {
    name: 'GallerySlider',
    loader: () => import('./components/gallery-slider')
  },
  {
    name: 'CareerPaths',
    loader: () => import('./components/career-paths')
  },
  {
    name: 'ProgramsListing',
    loader: () => import('./components/programs-listing')
  },
  {
    name: 'Tabs',
    loader: () => import('./components/tabs')
  },
  {
    name: 'CardRow',
    loader: () => import('./components/card-row')
  },
  {
    name: 'RelatedCardRow',
    loader: () => import('./components/related-card-row')
  },
  {
    name: 'FellowBobcats',
    loader: () => import('./components/fellow-bobcats')
  },
  {
    name: 'FullWidthMedia',
    loader: () => import('./components/full-width-media')
  },
  {
    name: 'SmallCards',
    loader: () => import('./components/small-cards')
  },
  {
    name: 'Databases',
    loader: () => import('./components/databases')
  },
  {
    name: 'HomeMedia',
    loader: () => import('./components/home-media')
  },
  {
    name: 'AudienceSelector',
    loader: () => import('./components/audience-selector')
  },
  {
    name: 'ContactForm',
    loader: () => import('./components/contact-form')
  },
  {
    name: 'CampaignForm',
    loader: () => import('./components/campaign-form')
  },
  {
    name: 'DataViz',
    loader: () => import('./components/data-viz')
  },
  {
    name: 'QuTodaySearch',
    loader: () => import('./components/qu-today-search')
  },
  {
    name: 'InTheMedia',
    loader: () => import('./components/in-the-media')
  },
  {
    name: 'QuTodayVideos',
    loader: () => import('./components/qu-today-videos')
  },
  {
    name: 'QuTodayVideoMasthead',
    loader: () => import('./components/qu-today-video-masthead')
  },
  {
    name: 'UpcomingEvents',
    loader: () => import('./components/upcoming-events')
  },
  {
    name: 'SubmitNews',
    loader: () => import('./components/submit-news')
  },
  {
    name: 'HighlightedSlider',
    loader: () => import('./components/highlighted-slider')
  },
  {
    name: 'TwoColumnAccordion',
    loader: () => import('./components/2-column-accordion.js')
  },
  {
    name: 'MagazineHeader',
    loader: () => import('./components/magazine-header.js')
  },
  {
    name: 'MagRecentSlider',
    loader: () => import('./components/mag-recent-slider.js')
  },
  {
    name: 'MagFeatured',
    loader: () => import('./components/mag-featured.js')
  },
  {
    name: 'MagMasthead',
    loader: () => import('./components/mag-masthead.js')
  },
  {
    name: 'QuTodayHeader',
    loader: () => import('./components/qu-today-header.js')
  },
  {
    name: 'VerticalImageContentRowNoWrap',
    loader: () => import('./components/vertical-image-content-row.js')
  },
  {
    name: 'QuTodayThreeColFeaturedContent',
    loader: () => import('./components/qu-today-three-col-featured-content.js')
  },
  {
    name: 'QuTodayRelatedArticles',
    loader: () => import('./components/qu-today-related-articles.js')
  },
  {
    name: 'ProjectGallery',
    loader: () => import('./components/project-gallery.js')
  },
  {
    name: 'FeaturedProjectsRow',
    loader: () => import('./components/featured-projects.js')
  },
  {
    name: 'UpcomingEventsCallout',
    loader: () => import('./modules/right-rail/upcoming-events-callout.js')
  },
  {
    name: 'VerticalVideosRow',
    loader: () => import('./components/vertical-videos-row.js')
  },
  // react components
  {
    name: 'StaffListing',
    loader: () => import('./react-components/staff-listing'),
    render: reactModule
  },
  {
    name: 'FacultyStaffListing',
    loader: () => import('./react-components/faculty-staff-listing'),
    render: reactModule
  },
  {
    name: 'EventsCalendar',
    loader: () => import('./react-components/events-calendar'),
    render: reactModule
  },
  {
    name: 'SearchResults',
    loader: () => import('./react-components/search-results'),
    render: reactModule
  },
  {
    name: 'TodaySearchResults',
    loader: () => import('./react-components/today-search-results'),
    render: reactModule
  },
  {
    name: 'DeansList',
    loader: () => import('./react-components/deans-list'),
    render: reactModule
  },
  {
    name: 'MagazineResults',
    loader: () => import('./react-components/magazine-results'),
    render: reactModule
  },
  {
    name: 'QuTodaySectionListing',
    loader: () => import('./react-components/today-section-listing'),
    render: reactModule
  },
  {
    name: 'ProgramExplorer',
    loader: () => import('./react-components/program-explorer'),
    render: reactModule
  },
  {
    name: 'ProjectListing',
    loader: () => import('./react-components/project-listing'),
    render: reactModule
  },
  {
    name: 'CountdownCallout',
    loader: () => import('./react-components/countdown-callout'),
    render: reactModule
  },
  {
    name: 'CounselorListing',
    loader: () => import('./react-components/counselor-listing'),
    render: reactModule
  },
  {
    name: 'AISearch',
    loader: () => import('./react-components/ai-search'),
    render: reactModule
  },
  {
    name: 'ClassNotesListing',
    loader: () => import('./react-components/class-notes-listing'),
    render: reactModule
  },
  {
    name: 'ProgramTypeSelector',
    loader: () => import('./components/program-type-selector')
  },
  {
    name: 'article-masthead',
    loader: () => import('./components/article-masthead')
  },
  {
    name: 'magazine-article-fw',
    loader: () => import('./components/magazine-article-fw')
  }
];

window._on('DOMContentLoaded', () => {
  initGlobalComponents();
  create(components);
});
